// RedesSociaisStyle.js

import styled, { keyframes } from 'styled-components';
import { colors } from '../../styles/variables';

// Animação de pulsação suave, igual à usada na Timeline.js
const pulse = keyframes`
  0%, 100% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.08);
  }
`;

export const RedesContainer = styled.section`
  padding: 40px 20px 75px;
  background-color: ${colors.background};
  text-align: center;
`;

export const SectionTitle = styled.h2`
  color: ${colors.text};
  font-size: 1.7em;
  margin-bottom: 0.5em;
`;

export const Subtitle = styled.p`
  color: ${colors.text};
  font-size: 0.9em;
  margin-bottom: 0.9em;

  span {
    color: ${colors.highlight};
  }
`;

// Texto com animação de pulsação suave igual à da Timeline.js
export const InteractiveText = styled.p`
  color: ${colors.highlight};
  font-size: 0.6em;
  margin-bottom: 20px;
  animation: ${pulse} 2.1s ease-in-out infinite;
`;

// Animação do esqueleto enquanto o embed do Instagram não chega.
const brilhar = keyframes`
  0%   { background-position: -180% 0; }
  100% { background-position: 180% 0; }
`;

export const EmbedContainer = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 20px;
  /* Reserva a altura antes do iframe chegar: sem isto a página "pula". */
  min-height: ${({ $pronto }) => ($pronto ? '0' : '420px')};

  iframe {
    border-radius: 10px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  }

  /* O blockquote cru do Instagram fica escondido até virar iframe. */
  blockquote.instagram-media:not([data-instgrm-payload-id]) {
    visibility: hidden;
  }
`;

export const Placeholder = styled.div`
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  max-width: 540px;
  margin: 0 auto;
  border-radius: 10px;
  border: 2px solid rgba(255, 255, 255, 0.06);
  background-image: linear-gradient(
    100deg,
    rgba(255, 255, 255, 0.03) 30%,
    rgba(255, 255, 255, 0.08) 50%,
    rgba(255, 255, 255, 0.03) 70%
  );
  background-size: 220% 100%;
  animation: ${brilhar} 1.4s linear infinite;
`;

export const PlaceholderTexto = styled.span`
  color: rgba(255, 255, 255, 0.35);
  font-size: 0.75em;
`;